import {
  CREATE_NEW_TEMP_USER,
  DEACTIVATE_TEMP_USER,
  EDIT_TEMP_USER_DIALOG,
  SHOW_TEMP_USER_DIALOG,
  SHOW_TEMP_USER_LINK
} from "../../../ducks/manageSurveyTempUsers";
import { FormattedMessage, injectIntl } from "react-intl";
import React, { Component } from "react";

import Button from "react-bootstrap/Button";
import CopyToClipboard from "react-copy-to-clipboard";
import ManageSurveyTempUserCreateAndEdit from "./ManageSurveyTempUserCreateAndEdit";
import ManageSurveyTempUserTable from "./ManageSurveyTempUserTable";
import Modal from "react-bootstrap/Modal";
import PropTypes from "prop-types";
import ModalHeader from "react-bootstrap/ModalHeader";
import { ModalTitle } from "react-bootstrap";

// TODO, FIXME!!

class ManageSurveyTempUser extends Component {
  constructor(props) {
    super(props);
    this.onShowInactive = this.onShowInactive.bind(this);
    this.updateTempUser = this.updateTempUser.bind(this);
    this.deactivateUser = this.deactivateUser.bind(this);
    this.close = this.close.bind(this);
  }

  close(popupToClose) {
    const { changeProperty } = this.props;
    popupToClose === SHOW_TEMP_USER_DIALOG
      ? this.onShowInactive(SHOW_TEMP_USER_DIALOG, false, true)
      : changeProperty(popupToClose, false);
  }

  deactivateUser() {
    const { deactivateTempUserAction, currentOverview, temporaryUserId } = this.props;
    deactivateTempUserAction(temporaryUserId, currentOverview.projectForeignId);
    this.close(DEACTIVATE_TEMP_USER);
  }

  updateTempUser() {
    const { updateTempUser, temporaryUserId, currentOverview } = this.props;
    updateTempUser(temporaryUserId, currentOverview.projectForeignId);
    this.close(EDIT_TEMP_USER_DIALOG);
  }

  onShowInactive(name, value, refreshRespondentList) {
    const { changeProperty, loadTempUsers, currentOverview, loadRespondentList } = this.props;
    changeProperty(name, value);
    loadTempUsers(currentOverview.projectForeignId);
    if (refreshRespondentList) {
      loadRespondentList();
    }
  }

  createEmailStructure(temporaryUserUsername, tempUserLink) {
    const { intl } = this.props;
    const text = intl.formatMessage({ id: "manage.survey.user.email.text" });
    const subject = encodeURIComponent(intl.formatMessage({ id: "manage.survey.user.email.subject" }));
    const body = encodeURIComponent(text + tempUserLink);
    let email = (
      <Button href={"mailto:" + temporaryUserUsername + "?subject=" + subject + "&body=" + body}>
        <FormattedMessage id={"manage.survey.user.send_email"} />
      </Button>
    );

    return email;
  }

  render() {
    const {
      showTempUserDialog,
      tempUserList,
      editTempUserDialog,
      createNewTempUser,
      deactivateTempUser,
      showTempUserLink
    } = this.props;
    return (
      <Modal className="manage-survey-temp-users-container" show={showTempUserDialog} size="xl">
        <ModalHeader>
          <ModalTitle>
            <FormattedMessage id={editTempUserDialog ? "manage.survey.user.edit.title" : "manage.survey.user.title"} />
          </ModalTitle>
        </ModalHeader>
        {editTempUserDialog || createNewTempUser
          ? this.renderEditCreateUser()
          : showTempUserLink
          ? this.renderShowTempUserLink()
          : deactivateTempUser
          ? this.renderDeactiveTempUser()
          : tempUserList
          ? this.renderTempUserTable()
          : null}
      </Modal>
    );
  }

  renderEditCreateUser() {
    const { editTempUserDialog, currentOverview, createNewRespondent } = this.props;
    let popupToclose = editTempUserDialog ? EDIT_TEMP_USER_DIALOG : CREATE_NEW_TEMP_USER;
    return [
      <ManageSurveyTempUserCreateAndEdit
        key="renderEditCreateUserBody"
        className="edit-temp-user-dialog"
        {...this.props}
      />,
      <Modal.Footer key="renderEditCreateUserFooter">
        {editTempUserDialog ? (
          <Button onClick={() => this.updateTempUser()}>
            <FormattedMessage id={"manage.survey.user.update"} />
          </Button>
        ) : (
          <Button
            //disabled={usernameAlreadyExists === true}

            onClick={() => createNewRespondent(currentOverview.projectForeignId, "createNewTempUser", false)}
          >
            <FormattedMessage id={"manage.survey.user.create"} />
          </Button>
        )}
        {this.renderCloseButton(popupToclose)}
      </Modal.Footer>
    ];
  }

  renderShowTempUserLink() {
    const { tempUserLink, temporaryUserUsername } = this.props;
    return [
      <Modal.Body key="renderShowTempUserLinkBody" className="show-temp-user-link">
        <FormattedMessage id="manage.survey.user.show.link.first.part" />
        <CopyToClipboard text={tempUserLink} onCopy={this.onCopy}>
          <button>
            <FormattedMessage id="manage.survey.user.copy" />
          </button>
        </CopyToClipboard>
        <FormattedMessage id="manage.survey.user.show.link.second.part" />
      </Modal.Body>,
      <Modal.Footer key="renderShowTempUserLinkFooter">
        {this.createEmailStructure(temporaryUserUsername, tempUserLink)}
        {this.renderCloseButton(SHOW_TEMP_USER_LINK)}
      </Modal.Footer>
    ];
  }

  renderTempUserTable() {
    const { changeProperty } = this.props;
    return [
      <ManageSurveyTempUserTable key="renderTempUserTableBody" {...this.props} />,
      <Modal.Footer key="renderTempUserTableFooter">
        <Button onClick={() => changeProperty("createNewTempUser", true)}>
          <FormattedMessage id={"manage.survey.user.add"} />
        </Button>
        {this.renderCloseButton(SHOW_TEMP_USER_DIALOG)}
      </Modal.Footer>
    ];
  }

  renderDeactiveTempUser() {
    return [
      <Modal.Body key="renderDeactiveTempUserBody" className="deactivate-temp-user-dialog">
        <FormattedMessage id="manage.survey.user.deactivate.first.part" />
        <FormattedMessage id="manage.survey.user.deactivate.second.part" />
        <FormattedMessage id="manage.survey.user.deactivate.third.part" />
      </Modal.Body>,
      <Modal.Footer key="renderDeactiveTempUserFooter">
        <Button onClick={() => this.deactivateUser()}>
          <FormattedMessage id={"manage.survey.user.deactivate"} />
        </Button>
        {this.renderCloseButton(DEACTIVATE_TEMP_USER)}
      </Modal.Footer>
    ];
  }

  renderCloseButton(popupToClose) {
    return (
      <Button variant="secondary" onClick={() => this.close(popupToClose)}>
        <FormattedMessage id="app.common.Close" />
      </Button>
    );
  }
}

ManageSurveyTempUser.propTypes = {
  showTempUserDialog: PropTypes.bool.isRequired,
  changeProperty: PropTypes.func,
  editTempUserDialog: PropTypes.bool,
  createNewTempUser: PropTypes.bool,
  deactivateTempUser: PropTypes.bool,
  showTempUserLink: PropTypes.bool,
  firstname: PropTypes.string,
  lastname: PropTypes.string,
  username: PropTypes.string,
  usernameAlreadyExists: PropTypes.bool,
  temporaryUserUsername: PropTypes.string,
  tempUserLink: PropTypes.string,
  temporaryUserId: PropTypes.number,
  currentOverview: PropTypes.object,
  createNewRespondent: PropTypes.func,
  loadTempUsers: PropTypes.func,
  updateTempUser: PropTypes.func,
  changeTempUserProperty: PropTypes.func,
  loadRespondentList: PropTypes.func,
  deactivateTempUserAction: PropTypes.func,
  tempUserList: PropTypes.array,
  dateOfValidity: PropTypes.string
};
export default injectIntl(ManageSurveyTempUser);
